import { render, staticRenderFns } from "./SectionAbout.vue?vue&type=template&id=04c0e385&scoped=true"
import script from "./SectionAbout.vue?vue&type=script&lang=ts"
export * from "./SectionAbout.vue?vue&type=script&lang=ts"
import style0 from "./SectionAbout.vue?vue&type=style&index=0&id=04c0e385&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c0e385",
  null
  
)

export default component.exports